import RestRequestFactory from '@core/utils/network/RestRequestFactory';
import config from '@config';
import slugify from '@core/utils/url/slugify';
export default class RestService {
    private readonly request: any;

    constructor(restRequestFactory = RestRequestFactory) {
        this.request = restRequestFactory.create(config.services.frontendServer);
    }

    public getStaticPage(pageName: string): Promise<any> {
        return this.request({
            url: `/nativewiki/${slugify(pageName)}`,
            method: 'get',
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/wiki/_private/RestService.ts